export const front = {
  phone: 'Phone',
  email: 'Email',
  country: 'Country',
  landingPage: 'Landing page',
  regDate: 'Reg. date',
  loading: 'Loading...',
  successful: 'Successful!'
}
